import React from "react";
import './loader.scss';
import Spinner from "../../assets/icons/loader.svg"
import SpinnerVersion2 from "../../assets/icons/loader-version-2.svg"
import NASpinner from "../../assets/icons/na-loader.svg";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/configureStore";
import {Config} from "../../../constants/Config";

const baseClass = 'clubFinder-loader'

const Loader = (): JSX.Element => {
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);

  let SpinnerIcon = Spinner;
  if (tenant === Config.tenantList.aflTenant) {
    SpinnerIcon = SpinnerVersion2
  } else if(tenant === Config.tenantList.naTenant) {
    SpinnerIcon = NASpinner;
  }

  return (
    <div className={`${baseClass}--wrapper`}>
      <img src={SpinnerIcon} alt="loader"/>
    </div>
  );
}

export default Loader;
